import Basement from '../../../assets/home/icons/basement.svg';
import Plumbing from '../../../assets/home/icons/plumbing.svg';
import Heating from '../../../assets/home/icons/heating.svg';
import Drywall from '../../../assets/home/icons/drywall.svg';
import Electrical from '../../../assets/home/icons/electrical.svg';
import Exterior from '../../../assets/home/icons/exterior.svg';


export const basement = Basement;
export const plumbing = Plumbing;
export const heating = Heating;
export const electrical = Electrical;
export const drywall = Drywall;
export const exterior = Exterior;
